import React from 'react';
import { Route } from 'react-router-dom';
import { AppRoute } from './routes.types';
import { RequireRole } from './guards/RequireRole';

const wrapWithGuards = (route: AppRoute): React.ReactNode => {
    if (route.roles && route.roles.length > 0) {
        return <RequireRole roles={route.roles}>{route.element}</RequireRole>;
    }
    return route.element;
};

export const renderRoutes = (routes: AppRoute[]): React.ReactNode =>
    routes.map((route) => (
        <Route
            key={route.path}
            path={route.path}
            element={wrapWithGuards(route)}
        >
            {route.children ? renderRoutes(route.children) : null}
        </Route>
    ));
